import modal from 'angular-ui-bootstrap/src/modal';
export const controlPresencia = angular.module('controlPresencia',
    [
        modal
    ]
);
window.controlPresencia = controlPresencia;

controlPresencia.config(['$interpolateProvider', function ($interpolateProvider) {
    $interpolateProvider.startSymbol('{%');
    $interpolateProvider.endSymbol('%}');
}]);

controlPresencia.config(['$httpProvider', function ($httpProvider) {
    $httpProvider.defaults.xsrfCookieName = $('meta[name="app-cookie-name"]').attr('content');
    $httpProvider.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
    $httpProvider.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
    $httpProvider.interceptors.push(['$q', '$rootScope', function ($q, $rootScope) {
        return {
            'request': function (config) {
                config.headers['X-Company-Context'] = $rootScope.context?.id ?? 0;
                return config || $q.when(config);
            },
            'responseError': function (response) {
                if (response.status === 401 || response.status === 409 || response.status === 408) {
                    window.location.href = '/';
                }
                return $q.reject(response);
            },
            'requestError': function (rejection) {
                if (rejection.status === 401 || rejection.status === 409 || rejection.status === 408) {
                    window.location.href = '/';
                }
                return $q.reject(rejection);
            }
        };
    }]);
}]);
